<template>
	<v-dialog v-model="dialog" max-width="500px">
		<v-card>
			<v-card-title>
				<span class="headline"> Zmiana hasła </span>
			</v-card-title>

			<v-card-text>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Stare hasło"
						label="Stare hasło"
						aria-label="old password"
						for="reset-password-dialog-old-password"
						id="reset-password-dialog-old-password"
						v-model="formData.oldPassword"
						data-vv-name="oldPassword"
						data-vv-as="Stare hasło"
						:type="showOldPass? 'text' : 'password'"
						:append-icon="showOldPass ? 'visibility' : 'visibility_off'"
						@click:append="showOldPass = !showOldPass"
						:error-messages="vErrors.collect('oldPassword')"
						@click="disableErrorMessage"
						v-validate="'required'"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Nowe hasło"
						label="Nowe hasło"
						aria-label="new password"
						for="reset-password-dialog-new-password"
						id="reset-password-dialog-new-password"
						v-model="formData.newPassword"
						data-vv-name="newPassword"
						data-vv-as="Nowe hasło"
						:type="showNewPass? 'text' : 'password'"
						:append-icon="showNewPass? 'visibility' : 'visibility_off'"
						@click:append="showNewPass = !showNewPass"
						:error-messages="vErrors.collect('newPassword')"
						@click="disableErrorMessage"
						v-validate="'required'"
					></v-text-field>
				</v-flex>
				<v-flex xs12>
					<v-text-field
						browser-autocomplete="off"
						name="Potwierdź nowe hasło"
						label="Potwierdź nowe hasło"
						aria-label="new password confirmation"
						for="reset-password-dialog-confirm-new-password"
						id="reset-password-dialog-confirm-new-password"
						v-model="formData.confirmationPassword"
						data-vv-name="confirmationPassword"
						data-vv-as="Nowe hasło"
						:type="showConfirmPass? 'text' : 'password'"
						:append-icon="showConfirmPass? 'visibility' : 'visibility_off'"
						@click:append="showConfirmPass = !showConfirmPass"
						:error-messages="vErrors.collect('confirmationPassword')"
						@click="disableErrorMessage"
						v-validate="'required'"
					></v-text-field>
				</v-flex>
				<v-expand-transition>
					<div v-show="showErrorMessage" style="color: red">
						{{errorMessage}}
					</div>
				</v-expand-transition>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue" @click="closeDialog">Anuluj</v-btn>
				<v-btn color="primary" flat @click="resetPassword">Zapisz</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import {Credentials} from "../../../api/generated/Credentials";
	import dataValidation from "../../../utils/dataValidation";

	export default {
		name: "ResetPasswordDialog",

		data() {
			return {
				formData: {
					oldPassword: '',
					newPassword: '',
					confirmationPassword: ''
				},
				dialog: true,
				errorMessage: '',
				showErrorMessage: false,

				showOldPass: false,
				showNewPass: false,
				showConfirmPass: false,
			};
		},

		methods: {

			closeDialog() {
				this.dialog = false;
			},

			disableErrorMessage() {
				this.showErrorMessage = false;
			},

			resetPassword() {
				this.$validator.validateAll().then((result) => {
					if (!result) return;
					let validationResult = dataValidation.validPassword(this.formData.newPassword, this.formData.confirmationPassword);
					if (validationResult === "OK") {
						if (this.formData.oldPassword === this.formData.newPassword) {
							this.errorMessage = "Nowe hasło nie może być takie samo jak poprzednie";
							this.showErrorMessage = true;
							return;
						}
						Credentials.putResetPassword(this, this.formData, successResponse => {
								this.closeDialog();
								this.$messagesBus.$emit("success", "Hasło zostało pomyślnie zmienione", successResponse);
							},
							errorResponse => {
								this.errorMessage = errorResponse.errors[0];
								this.showErrorMessage = true;
							});
					} else {
						this.errorMessage = validationResult;
						this.showErrorMessage = true;
					}
				});
			},
		},

		watch: {
			dialog(val) {
				!val && this.$emit("closeDialog") && this.vErrors.clear();
			}
		}
	};
</script>

<style scoped>

</style>
